import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import axios from 'axios';
import { useToast } from './ui/use-toast';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

const AddOwnerModal = ({ clientId, onClose }) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    title: 'OWNER',
    ownership_percent: '100',
    ownership_date: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('mcaToken');
      await axios.post(`${API_BASE}/clients/${clientId}/owners`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: 'Success', description: 'Owner added successfully' });
      onClose();
    } catch (error) {
      toast({ title: 'Error', description: 'Failed to add owner', variant: 'destructive' });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Add Owner</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={24} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Owner Name *</label>
            <Input
              required
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              placeholder="Enter owner name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Title *</label>
            <Input
              required
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              placeholder="OWNER"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Ownership % *</label>
            <Input
              required
              type="number"
              value={formData.ownership_percent}
              onChange={(e) => setFormData({...formData, ownership_percent: e.target.value})}
              placeholder="100"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Ownership Date</label>
            <Input
              type="date"
              value={formData.ownership_date}
              onChange={(e) => setFormData({...formData, ownership_date: e.target.value})}
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button type="submit" className="flex-1 bg-green-600 hover:bg-green-700">Add Owner</Button>
            <Button type="button" variant="outline" onClick={onClose} className="flex-1">Cancel</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOwnerModal;